class VariavelGlobal{

static var1 
static var2
static var3
static ButtonEnable
}
export default VariavelGlobal